const ID_TOKEN_KEY = "id_token_client";
const USER_PROFILE_KEY = "$che";

export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = async (token) => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
    window.localStorage.removeItem(USER_PROFILE_KEY);
};

export const saveUserData = (udata) => {
    window.localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(udata));
};

export const getUserData = () => {
    let userData = window.localStorage.getItem(USER_PROFILE_KEY);
    if (userData && userData !== undefined) {
        return JSON.parse(userData);
    }
    return false;
};

export default { getToken, saveToken, destroyToken, saveUserData, getUserData };
